type IconProps = {
  name: string
  size?: number
  color?: string
  fill?: boolean
  weight?: number
  className?: string
}

export default function Icon({ name, size = 18, color, fill = false, weight = 400, className }: IconProps) {
  return (
    <span
      className={['material-symbols-rounded', className].filter(Boolean).join(' ')}
      style={{
        fontSize: `${size}px`,
        color,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}`,
      }}
    >
      {name}
    </span>
  )
}
